<template>
  <v-layout
    justify-left
    wrap>
    <v-flex md12>
      <h3 class="heading-4 mb-0">Repayment detail - {{ repayment.Id }} ({{ repayment.Status }})</h3>
    </v-flex>

    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.factoring.generalinfo' | translate }}</h3>
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.id'| translate }} ({{ 'krita.status'| translate }})</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.Id }} ({{ repayment.Status }})</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.debtorname'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.DebtorName }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.debtorid'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right"><router-link :to="{name:'', params:{id: ''}}">{{ repayment.DebtorId }}</router-link></v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.expirationdate'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.ExpirationDate | date }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.created'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.Created | date }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.createdby'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.CreatedBy }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.type'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.RepaymentType }}</v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>

    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.repayment.amountsonrepayment' | translate }}</h3>
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>
              {{ 'krita.repayment.capital' | translate }}
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.Capital | amount }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              {{ 'krita.repayment.currpenaltyinterest' | translate }}
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.Penalty | amount }}</v-flex>
          </v-layout>
          <hr>
          <v-layout row>
            <v-flex md6>
              {{ 'krita.repayment.total' | translate }}
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ repayment.Capital + repayment.Penalty | amount }}</v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>

    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.repayment.bankclaiminfo' | translate }}</h3>
          <!--<v-img-->
          <!--:src="logo"-->
          <!--contain-->
          <!--height="50"-->
          <!--/>-->
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.debtorregistryid' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.DebtorId | kennitala }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.account' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.Account | account }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.capital' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.Amount | amount }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.duedate' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.DueDate | date }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.repayment.finalduedate' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.FinalDueDate | date }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.status' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ bankClaim.Status }}</v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
    export default {
        name: "RepaymentDetailInfo",
        props: ['bankClaim','repayment'],
        computed: {
        }
    }
</script>

<style scoped>

</style>
